import { useCallback } from 'react';
import {
  Tag,
  TagLabel,
  TagProps,
  Checkbox,
  HbTooltip,
  Text,
} from '@cdl/heartbeat-react';
import { useDispatch, useSelector } from 'react-redux';
import { getLabelStatusSelector } from '../selectors/auto-labels.selectors';
import * as autoLabelsActions from '../actions/auto-labels.actions';

type Props = {
  label: string;
  code: string;
} & TagProps;

export const AutoLabel: React.FC<Props> = ({ label, code, ...rest }) => {
  const isChecked = useSelector(getLabelStatusSelector(code));
  const dispatch = useDispatch();
  const handleClick = useCallback(
    (code: string) => {
      dispatch(
        autoLabelsActions.toggleCodeAssessment({
          code,
          meta: { history: false },
        }),
      );
    },
    [dispatch],
  );

  return (
    <Checkbox
      isChecked={isChecked}
      onChange={() => handleClick(code)}
      title={label}
    >
      <Tag data-testid='diagnostic-label' size='sm' {...rest}>
        <HbTooltip
          hasArrow
          label={
            <>
              <Text>{label}</Text>
            </>
          }
        >
          <TagLabel mr='s' textTransform='none'>
            {label}
          </TagLabel>
        </HbTooltip>
      </Tag>
    </Checkbox>
  );
};
